import { render, staticRenderFns } from "./sessionai2.vue?vue&type=template&id=28168fce&scoped=true"
import script from "./sessionai2.vue?vue&type=script&lang=ts"
export * from "./sessionai2.vue?vue&type=script&lang=ts"
import style0 from "./sessionai2.vue?vue&type=style&index=0&id=28168fce&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28168fce",
  null
  
)

export default component.exports